import { ILoginDetails } from "@Models/ILoginDetails";
import React, { useContext } from "react";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import { Button, Form, Input, Typography } from "antd";

interface LoginFormProps {
    onSubmit: (values: ILoginDetails) => Promise<void>;
    onResetPassword: () => void;
    fetching: boolean;
}

const { Title } = Typography;

const LoginForm: React.FC<LoginFormProps> = (props) => {
    const { ui: uiState } = useContext(MainContext);
    return (
        <div id="login-form">
            <Title
                level={2}
                className="login-title"
                style={uiState.mode === ViewMode.desktop ? null : { color: "#fff" }}
            >
                Welcome.
            </Title>
            <Form
                initialValues={{} as ILoginDetails}
                requiredMark={false}
                onFinish={async (values: ILoginDetails) => {
                    await props.onSubmit(values);
                }}
                style={{
                    width: "100%",
                }}
            >
                <Form.Item
                    name="login"
                    rules={[{ required: true, type: "email", message: "Please enter a valid email address" }]}
                >
                    <Input placeholder="Email" className="login-item" />
                </Form.Item>

                <Form.Item name="password" rules={[{ required: true, message: "Please enter your password." }]}>
                    <Input.Password placeholder="Password" className="login-item" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={props.fetching} className="submit-button">
                        {props.fetching ? null : (
                            <Title level={4} style={{ marginBottom: "0px" }}>
                                Login
                            </Title>
                        )}
                    </Button>
                </Form.Item>
                <a
                    onClick={props.onResetPassword}
                    className="reset-password-link"
                    style={uiState.mode === ViewMode.desktop ? null : { color: "#fff" }}
                >
                    Forgot your password?
                </a>
            </Form>
        </div>
    );
};
export default LoginForm;
